import { buildDemoFreights } from '../../data/buildDemoFreights';
import { ChartColors } from '../constants';

const summary = [
    { key: 'total', title: 'Total Freights', amount: 48, rate: '+12%', trend: 'up' },
    { key: 'open', title: 'Open for Bids', amount: 18, rate: '+5%', trend: 'up' },
    { key: 'transit', title: 'In Transit', amount: 9, rate: '-10%', trend: 'down' },
    { key: 'delivered', title: 'Delivered', amount: 9, rate: '+28%', trend: 'up' },
    { key: 'closed', title: 'Closed', amount: 1, rate: '0%', trend: 'up' },
];

const freightStatus = [
    { key: 'drafts', label: 'Drafts', value: 12, color: ChartColors.primary },
    { key: 'open_for_bids', label: 'Open for Bids', value: 18, color: ChartColors.info },
    { key: 'in_transit', label: 'In Transit', value: 9, color: ChartColors.warning },
    { key: 'delivered', label: 'Delivered', value: 9, color: ChartColors.success },
    { key: 'closed', label: 'Closed', value: 1, color: ChartColors.danger },
];

const verificationResults = [
    { key: 'auto_accepted', label: 'Auto Accepted', value: 18, color: ChartColors.success },
    { key: 'manual_review', label: 'Manual Review', value: 8, color: ChartColors.warning },
    { key: 'auto_rejected', label: 'Auto Rejected', value: 6, color: ChartColors.danger },
];

const bidsOverTime = {
    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    amounts: [6, 9, 7, 11, 8, 12, 10, 14, 13, 16, 15, 19],
};

const attentionItems = [
    {
        id: 1,
        type: 'manual_review',
        title: '3 bids need manual review',
        description: 'Carriers require additional checks',
    },
    {
        id: 2,
        type: 'draft',
        title: '2 freights in draft',
        description: 'Complete and publish to receive bids',
    },
    {
        id: 3,
        type: 'closing_soon',
        title: '1 freight closing soon',
        description: 'Bidding ends in less than 24 hours',
    },
];

class CarrierGuardDashboardService {
    static getInstance() {
        return new CarrierGuardDashboardService();
    }

    async fetchDashboard() {
        const recentFreights = [...buildDemoFreights()]
            .sort((first, second) => second.createdAt.localeCompare(first.createdAt))
            .slice(0, 5);

        return {
            summary,
            freightStatus: {
                segments: freightStatus,
                total: freightStatus.reduce((total, segment) => total + segment.value, 0),
            },
            verificationResults: {
                segments: verificationResults,
                total: verificationResults.reduce((total, segment) => total + segment.value, 0),
            },
            bidsOverTime,
            recentFreights,
            attentionItems,
        };
    }
}

export default CarrierGuardDashboardService;
